/* eslint-disable no-throw-literal */
import apiClient from './apiClient.js';

export const getAppsignaturePreviewByIdUser = (id) => apiClient.post(`/signature-management/preview/domain-user/${id}`);
export const updateAppUserEmailSignature = (id) => apiClient.post(`/signature-management/update-email-signature/domain-user/${id}`);
